import React, { useEffect, useState } from "react";
import { Button, Col, Row } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setMaterialTemplateIsEdit } from "./redux/actions";
import MaterialTemplatesTable from "./materialTemplatesTable";
import './index.less'

const MaterialTemplatesManager = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [canUpdate, setCanUpdate] = useState(false);
  const { user } = useSelector((state) => state.authReducer);

  useEffect(() => {
    if (user?.permissions?.material_templates?.add_edit) {
      setCanUpdate(true);
    }
  }, [user]);

  return (
    <div className="page-top-div">
      <span className="text-span">Material Template Manager</span>
      <Row className="production-manager-parent-row">
        <Col span={24} className="heading-col">
          <Row align="middle" gutter={[50, 0]}>
            <Col>
              <div>
                <span className="heading-span template-header-text">
                  Templates Register
                </span>
              </div>
            </Col>
            <Col>
              {canUpdate && (
                <Button
                  onClick={() => {
                    navigate(
                      "/settings/material-templates/create-template"
                    );
                    dispatch(setMaterialTemplateIsEdit(true));
                  }}
                  icon={<PlusOutlined />}
                  className="add-user-btn"
                  size="middle"
                  style={{ width: "120px", fontSize: "13px", fontWeight: 600 }}
                >
                  TEMPLATE
                </Button>
              )}
            </Col>
          </Row>
        </Col>

        <Col span={24} style={{ borderTop: 'none', marginTop: '-1px' }}
        >
          <MaterialTemplatesTable canUpdate={canUpdate} />
        </Col>
      </Row>
    </div>
  );
};

export default MaterialTemplatesManager;
